export default "__VITE_ASSET__BbxTzmI7__"